<ng-content select="header" />

@switch (mode()) {
	@case ('detail') {
		<div class="page-template__scroll-container">
			<ng-container [ngTemplateOutlet]="contentTemplate" />
		</div>
	}
	@case ('table') {
		<ng-container [ngTemplateOutlet]="contentTemplate" />
	}
}

<ng-template #contentTemplate>
	<ng-content />
</ng-template>
